// import React from 'react'
// import  './Nav.css'
// import Toggle from './Toggle'

// export const Navbar = () => {
//     return (
        
//         <div className="n-wrap">
//           <div  className="n-left">
//             <div className="n-name"> Aman</div>
//             <span><Toggle/></span>
//           </div>
//           <div className='n-right'>
//             <div className='n-list'>
//               <ul  style={{ listStyleType: "none" }}>
//               <li>Home</li>
//             <li>About</li>
//             <li>Skill</li>
//             <li>project</li>
//             <li>Resume</li>
//               </ul>
//             </div>
//             <button className="button-contact button">Contact me</button>
//           </div>
//         </div>
        
//     )import React from "react";
import Toggle from "./Toggle";
import "./Nav.css";
import { Link } from "react-scroll";
export const Navbar = () => {
  return (
    <div className="n-wrapper" id="Navbar">
      {/* left */}
      <div className="n-left">
        <div className="n-name"><a href="portfolio-aman-dubey.netlify.app" style={{textDecoration: 'none'}}>Aman</a> </div>
        <Toggle />
      </div>
      {/* right */}
      <div className="n-right">
        <div className="n-list">
          <ul style={{ listStyleType: "none" }}>
            <li>
              <Link activeClass="active" to="Navbar" spy={true} smooth={true}>
                Home
              </Link>
            </li>
            <li>
              <Link to="about" spy={true} smooth={true}>
                About
              </Link>
            </li>
            <li>
              <Link to="skills" spy={true} smooth={true}>
                Skills
              </Link>
            </li>
            <li>
              <Link to="portfolio" spy={true} smooth={true}>
                Projects
              </Link>
            </li>
            {/* <li>
              <Link to="blog" spy={true} smooth={true}>
                Blog
              </Link>
            </li> */}
          </ul>
        </div>
        <Link to="contact" spy={true} smooth={true}>
        <button className="button n-button">Contact</button>
        </Link>
      </div>
    </div>
  );
};

// export default navbar;
// }
